import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

import Course from './course'
import My from './my'
import Shop from './shop'
import Buy from './buy'

const ActivityRoute = ({ match }) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={`${match.url}/course`} component={Course} />
        <Route path={`${match.url}/my`} component={My} />
        <Route path={`${match.url}/shop`} component={Shop} />
        <Route path={`${match.url}/buy`} component={Buy} />
        <Redirect to={`${match.url}/shop/index`}/>
      </Switch>
    </BrowserRouter>
  )
}

export default ActivityRoute
